/* Truefit order builder. Reads window.TB_CFG. In mock mode it shows what Shopify would receive; otherwise it posts one cart line per jersey. */
(function () {
  'use strict';
  var CFG = window.TB_CFG;
  var root = document.getElementById('tb-root');
  if (!CFG || !root) return;

  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var LS = 'tb-draft-' + (CFG.storageKey || 'v1');

  var HINTS = { XS: '4′3″–4′7″', S: '4′7″–4′11″', M: '4′11″–5′1″', L: '5′1″–5′5″', XL: '5′5″–5′7″', '2XL': '5′7″–5′9″', '3XL': '5′9″–5′11″', '4XL': '5′11″–6′1″', '5XL': '6′1″–6′3″', '6XL': '6′3″–6′5″' };
  var MAX = CFG.maxJerseys || 40;
  var LOGO = CFG.logo || {};
  var MIN_PX = LOGO.minPx || 1000, REC_PX = LOGO.recPx || 1500, MAX_MB = LOGO.maxMb || 10;

  var uid = 0;
  function newRow(o) {
    var r = { id: ++uid, size: '', num: '', backDiff: false, backNum: '', name: '', noName: false, team: '' };
    if (o) for (var k in o) r[k] = o[k];
    return r;
  }
  var S = { team: '', noTeam: false, teamEach: false, rows: [newRow()], logo: null, tried: false, undo: null };
  var sizeById = {};
  (CFG.sizes || []).forEach(function (s) { s.hint = s.hint || HINTS[s.label] || ''; sizeById[s.label] = s; });

  /* ---------- helpers ---------- */
  var nf = null;
  try { nf = new Intl.NumberFormat(CFG.locale || undefined, { style: 'currency', currency: CFG.currency || 'USD' }); } catch (e) { nf = null; }
  function money(n) { return nf ? nf.format(n) : '$' + n.toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function cleanText(v, max) {
    var s;
    try { s = v.replace(/[^\p{L}\p{N} .'&\-]/gu, ''); } catch (e) { s = v.replace(/[^A-Za-z0-9 .'&\-]/g, ''); }
    s = s.replace(/\s{2,}/g, ' ').replace(/^\s+/, '');
    return s.toLocaleUpperCase().slice(0, max);
  }
  function digits(v) { return v.replace(/\D/g, '').slice(0, 2); }
  function validNum(v) { return /^\d{1,2}$/.test(v); }
  function effTeam(r) { return (S.teamEach && r.team) ? r.team : S.team; }
  function plural(n, w) { return n + ' ' + w + (n === 1 ? '' : 's'); }
  function scrollTo(el) { if (el && el.scrollIntoView) el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); }
  function rowById(id) { for (var i = 0; i < S.rows.length; i++) if (S.rows[i].id === id) return S.rows[i]; return null; }

  function issues(r) {
    var a = [];
    if (!r.size) a.push('size');
    if (!validNum(r.num)) a.push('number');
    if (r.backDiff && !validNum(r.backNum)) a.push('back number');
    if (!r.noName && !r.name.trim()) a.push('name');
    if (S.teamEach && !S.noTeam && !effTeam(r).trim()) a.push('team name');
    return a;
  }
  function teamOk() { return S.noTeam || !!S.team.trim() || (S.teamEach && S.rows.every(function (r) { return !!r.team.trim(); })); }

  /* ---------- persistence ---------- */
  var saveT = null;
  function save() {
    clearTimeout(saveT);
    saveT = setTimeout(function () {
      try { localStorage.setItem(LS, JSON.stringify({ t: S.team, nt: S.noTeam, te: S.teamEach, r: S.rows, l: S.logo, u: uid })); } catch (e) {}
    }, 250);
  }
  function load() {
    try {
      var j = JSON.parse(localStorage.getItem(LS) || 'null');
      if (!j || !j.r || !j.r.length) return false;
      var rows = j.r.slice(0, MAX).map(function (r) {
        return newRow({ size: sizeById[r.size] ? r.size : '', num: digits(String(r.num || '')), backDiff: !!r.backDiff, backNum: digits(String(r.backNum || '')), name: cleanText(String(r.name || ''), 14), noName: !!r.noName, team: cleanText(String(r.team || ''), 16) });
      });
      var touched = j.t || j.l || rows.some(function (r) { return r.size || r.num || r.name; });
      if (!touched) return false;
      S.team = cleanText(String(j.t || ''), 16); S.noTeam = !!j.nt; S.teamEach = !!j.te;
      S.rows = rows; S.logo = j.l && j.l.url ? j.l : null;
      return true;
    } catch (e) { return false; }
  }

  /* ---------- toast ---------- */
  var toastT = null;
  function toast(msg, label, fn) {
    var t = $('#tb-toast');
    t.innerHTML = '<span>' + esc(msg) + '</span>' + (label ? '<button type="button">' + esc(label) + '</button>' : '');
    t.hidden = false;
    if (label) t.querySelector('button').onclick = function () { t.hidden = true; fn(); };
    clearTimeout(toastT);
    toastT = setTimeout(function () { t.hidden = true; }, label ? 7000 : 3200);
  }

  /* ---------- preview colours (set per product in the section settings) ---------- */
  function applyPalette() {
    var d = CFG.preview || {};
    function hex(v, fb) { v = (v || '').trim(); return /^#[0-9a-f]{3,8}$/i.test(v) ? v : fb; }
    var bg = hex(d.bg, '#0F0F0F'), fg = hex(d.fg, '#CDA349');
    root.style.setProperty('--pb', bg);
    root.style.setProperty('--pb2', hex(d.bg2, bg));
    root.style.setProperty('--pf', fg);
    root.style.setProperty('--pt', hex(d.trim, fg));
  }
  function fillProduct() {
    var p = CFG.product || {};
    var el = $('#tb-prod'); if (!el) return;
    if (!p.name) { el.hidden = true; return; }
    $('#tb-prod-name').textContent = p.name;
    $('#tb-prod-sub').textContent = p.sub || '';
    var im = $('#tb-prod-img'); if (p.img) { im.src = p.img; im.hidden = false; } else im.hidden = true;
  }

  /* ---------- step 2 : logo ---------- */
  var dropSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 16V4"/><path d="M7 9l5-5 5 5"/><path d="M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3"/></svg>';
  var logoErr = '';
  var upload = null; // {name, pct}

  function renderLogo() {
    var z = $('#tb-logo-zone'), h = '';
    var link = LOGO.mode === 'link';
    if (upload) {
      h = '<div class="tb-logo"><div class="tb-lthumb" aria-hidden="true">' + (upload.thumb ? '<img src="' + esc(upload.thumb) + '" alt="">' : '') + '</div>' +
        '<div class="tb-lmeta"><div class="tb-lname">' + esc(upload.name) + '</div><div class="tb-ldim">Uploading… <span id="tb-up-pct">' + upload.pct + '</span>%</div>' +
        '<div class="tb-bar-prog"><i id="tb-up-bar" style="width:' + upload.pct + '%"></i></div></div></div>';
    } else if (S.logo) {
      var L = S.logo, dim = L.link ? 'Link saved' : (L.vector ? 'Vector file' : (L.w + ' × ' + L.h + ' px'));
      var badge = L.link ? '' : (L.grade === 'great' ? '<span class="tb-badge is-great">Great for printing</span>' : '<span class="tb-badge is-ok">OK, a larger file prints sharper</span>');
      h = '<div class="tb-logo"><div class="tb-lthumb">' + (L.thumb ? '<img src="' + esc(L.thumb) + '" alt="Your logo preview">' : '<span aria-hidden="true">🔗</span>') + '</div>' +
        '<div class="tb-lmeta"><div class="tb-lname">' + esc(L.name) + '</div><div class="tb-ldim">' + esc(dim) + '</div>' + badge +
        '<div class="tb-lbtns"><button type="button" class="tb-ibtn" data-logo="replace">Replace</button><button type="button" class="tb-ibtn" data-logo="remove">Remove</button></div></div></div>' +
        '<input class="tb-file" id="tb-file" type="file" accept=".png,.jpg,.jpeg,.svg,.webp,image/png,image/jpeg,image/svg+xml,image/webp" tabindex="-1">';
    } else if (link) {
      h = '<div class="tb-f" id="tb-linkf"><div class="tb-lrow"><label for="tb-logo-link">Link to your logo <span class="tb-hint">Google Drive, Dropbox or any public link</span></label></div>' +
        '<input class="tb-in" id="tb-logo-link" type="url" inputmode="url" placeholder="https://" autocomplete="off"><p class="tb-err">Enter a link that starts with https://</p></div>';
    } else {
      h = '<label class="tb-drop" id="tb-drop" for="tb-file">' + dropSvg + '<b>Drop your logo here or choose a file</b><span>PNG, SVG or JPG</span></label>' +
        '<input class="tb-file" id="tb-file" type="file" accept=".png,.jpg,.jpeg,.svg,.webp,image/png,image/jpeg,image/svg+xml,image/webp">';
    }
    if (logoErr) h += '<p class="tb-lerr" role="alert">' + esc(logoErr) + '</p>';
    z.innerHTML = h;
  }

  function readMeta(f) {
    return new Promise(function (resolve, reject) {
      var isSvg = /svg/i.test(f.type) || /\.svg$/i.test(f.name);
      var fr = new FileReader();
      fr.onerror = reject;
      fr.onload = function () {
        if (isSvg) return resolve({ vector: true, w: 0, h: 0, thumb: fr.result });
        var img = new Image();
        img.onerror = reject;
        img.onload = function () {
          var w = img.naturalWidth, h = img.naturalHeight, c = document.createElement('canvas'), k = Math.min(1, 160 / Math.max(w, h));
          c.width = Math.max(1, Math.round(w * k)); c.height = Math.max(1, Math.round(h * k));
          c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
          var thumb = ''; try { thumb = c.toDataURL('image/png'); } catch (e) {}
          resolve({ vector: false, w: w, h: h, thumb: thumb });
        };
        img.src = fr.result;
      };
      fr.readAsDataURL(f);
    });
  }

  function handleFile(f) {
    logoErr = '';
    if (!f) return;
    var okType = /^image\/(png|jpeg|svg\+xml|webp)$/.test(f.type) || /\.(png|jpe?g|svg|webp)$/i.test(f.name);
    if (!okType) { logoErr = 'That file type is not supported. Upload a PNG, SVG or JPG.'; return renderLogo(); }
    if (f.size > MAX_MB * 1048576) { logoErr = 'That file is over ' + MAX_MB + ' MB. Export a smaller version and try again.'; return renderLogo(); }
    readMeta(f).then(function (m) {
      var short = Math.min(m.w, m.h);
      if (!m.vector && short < MIN_PX) {
        logoErr = 'This image is ' + m.w + ' × ' + m.h + ' px. The shortest side needs to be at least ' + MIN_PX + ' px so it prints sharp. Upload a larger file or an SVG.';
        return renderLogo();
      }
      var grade = (m.vector || short >= REC_PX) ? 'great' : 'ok';
      startUpload(f, m, grade);
    }).catch(function () { logoErr = 'We could not read that image. Export it again as a PNG and try again.'; renderLogo(); });
  }

  function finishUpload(f, m, grade, url) {
    upload = null;
    S.logo = { name: f.name, url: url, w: m.w, h: m.h, vector: m.vector, grade: grade, thumb: m.thumb || '' };
    renderLogo(); updateSummary(); save();
  }
  function startUpload(f, m, grade) {
    upload = { name: f.name, pct: 0, thumb: m.thumb || '' };
    renderLogo();
    function setPct(p) {
      upload.pct = p;
      var a = $('#tb-up-pct'), b = $('#tb-up-bar');
      if (a) a.textContent = p; if (b) b.style.width = p + '%';
    }
    function fail(msg) { upload = null; logoErr = msg; renderLogo(); }
    if (CFG.mock || !LOGO.cloudName) {
      var p = 0, iv = setInterval(function () {
        p += 14 + Math.round(Math.random() * 10);
        if (p >= 100) { clearInterval(iv); setPct(100); setTimeout(function () { finishUpload(f, m, grade, 'https://res.cloudinary.com/demo/truefit-logos/' + encodeURIComponent(f.name)); }, 180); }
        else setPct(p);
      }, 110);
      return;
    }
    var fd = new FormData();
    fd.append('file', f);
    fd.append('upload_preset', LOGO.preset);
    if (LOGO.folder) fd.append('folder', LOGO.folder);
    var x = new XMLHttpRequest();
    x.open('POST', 'https://api.cloudinary.com/v1_1/' + encodeURIComponent(LOGO.cloudName) + '/image/upload');
    x.upload.onprogress = function (e) { if (e.lengthComputable) setPct(Math.min(99, Math.round(e.loaded / e.total * 100))); };
    x.onload = function () {
      var j = null; try { j = JSON.parse(x.responseText); } catch (e) {}
      if (x.status >= 200 && x.status < 300 && j && j.secure_url) finishUpload(f, m, grade, j.secure_url);
      else fail('The upload did not finish. Check your connection and try again.');
    };
    x.onerror = function () { fail('The upload did not finish. Check your connection and try again.'); };
    x.send(fd);
  }

  /* ---------- step 3 : rows ---------- */
  var JERSEY_FRONT = 'M62 10 L82 10 L100 50 L118 10 L138 10 Q132 58 150 84 L150 222 Q100 236 50 222 L50 84 Q68 58 62 10 Z';
  var JERSEY_BACK = 'M62 10 L84 10 Q100 26 116 10 L138 10 Q132 58 150 84 L150 222 Q100 236 50 222 L50 84 Q68 58 62 10 Z';
  function svgFront() {
    return '<svg viewBox="0 0 200 240" aria-hidden="true"><path class="tb-jb" d="' + JERSEY_FRONT + '"/>' +
      '<text class="tb-jt" data-t="team" x="100" y="108" font-size="18">TEAM</text>' +
      '<text class="tb-jt" data-t="num" x="100" y="184" font-size="60">00</text></svg>';
  }
  function svgBack() {
    return '<svg viewBox="0 0 200 240" aria-hidden="true"><path class="tb-jb" d="' + JERSEY_BACK + '"/>' +
      '<text class="tb-jt" data-t="name" x="100" y="80" font-size="20">NAME</text>' +
      '<text class="tb-jt" data-t="bnum" x="100" y="186" font-size="66">00</text></svg>';
  }
  function sizeOptions(sel) {
    var h = '<option value=""' + (sel ? '' : ' selected') + '>Select size</option>';
    (CFG.sizes || []).forEach(function (s) {
      h += '<option value="' + esc(s.label) + '"' + (s.label === sel ? ' selected' : '') + (s.available === false ? ' disabled' : '') + '>' + esc(s.label) + (s.hint ? ' · ' + esc(s.hint) : '') + (s.available === false ? '  (sold out)' : '') + '</option>';
    });
    return h;
  }

  function rowHTML(r, i) {
    var p = 'r' + r.id;
    return '<article class="tb-row" data-row="' + r.id + '" role="group" aria-label="Jersey ' + (i + 1) + '">' +
      '<header class="tb-row-h"><span class="tb-rn">Jersey ' + (i + 1) + '</span><span class="tb-rstate"></span>' +
      '<div class="tb-rtools"><button type="button" class="tb-ibtn" data-act="same">+ Same size</button><button type="button" class="tb-ibtn" data-act="del"' + (S.rows.length < 2 ? ' disabled' : '') + '>Remove</button></div></header>' +
      '<div class="tb-row-b"><div class="tb-prev"><figure class="tb-pf">' + svgFront() + '<figcaption>Front</figcaption></figure><figure class="tb-pb">' + svgBack() + '<figcaption>Back</figcaption></figure></div>' +
      '<div class="tb-fields">' +
        '<div class="tb-f tb-f-size" data-f="size"><div class="tb-lrow"><label for="' + p + '-size">Size <span class="tb-hint">height</span></label></div><select class="tb-in" id="' + p + '-size" data-k="size">' + sizeOptions(r.size) + '</select><p class="tb-err">Choose a size</p></div>' +
        '<div class="tb-f tb-f-num" data-f="num"><div class="tb-lrow"><label for="' + p + '-num">Number</label></div><input class="tb-in" id="' + p + '-num" data-k="num" type="text" inputmode="numeric" pattern="[0-9]*" maxlength="2" autocomplete="off" placeholder="23" value="' + esc(r.num) + '"><p class="tb-err">Enter 0 to 99</p></div>' +
        '<div class="tb-f tb-f-name" data-f="name"><div class="tb-lrow"><label for="' + p + '-name">Name on the back</label><span class="tb-count">' + r.name.length + '/14</span></div><input class="tb-in" id="' + p + '-name" data-k="name" type="text" maxlength="14" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="JORDAN"' + (r.noName ? ' disabled' : '') + ' value="' + esc(r.name) + '"><p class="tb-err">Enter a name, or tick "No name"</p>' +
          '<label class="tb-chk tb-name-chk"><input type="checkbox" data-k="noName"' + (r.noName ? ' checked' : '') + '> No name on the back</label></div>' +
        '<button type="button" class="tb-linkbtn" data-act="bnum">' + (r.backDiff ? 'Use the same number on the back' : 'Back number is different') + '</button>' +
        '<div class="tb-f tb-f-bnum" data-f="bnum"' + (r.backDiff ? '' : ' hidden') + '><div class="tb-lrow"><label for="' + p + '-bnum">Number on the back</label></div><input class="tb-in" id="' + p + '-bnum" data-k="backNum" type="text" inputmode="numeric" pattern="[0-9]*" maxlength="2" autocomplete="off" placeholder="23" value="' + esc(r.backNum) + '"><p class="tb-err">Enter 0 to 99</p></div>' +
        '<div class="tb-f tb-f-team" data-f="rteam"' + (S.teamEach ? '' : ' hidden') + '><div class="tb-lrow"><label for="' + p + '-team">Team name for this jersey</label><span class="tb-hint">leave empty to use the team name above</span></div><input class="tb-in" id="' + p + '-team" data-k="team" type="text" maxlength="16" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="' + esc(S.team || 'Same as above') + '" value="' + esc(r.team) + '"></div>' +
      '</div></div></article>';
  }

  function renderRows() {
    $('#tb-rows').innerHTML = S.rows.map(rowHTML).join('');
    $('#tb-qty').value = S.rows.length;
    $('#tb-addrow').disabled = S.rows.length >= MAX;
    paintAll();
  }

  function fillText(svg, k, val, ph, base, maxw) {
    var t = svg.querySelector('[data-t="' + k + '"]'); if (!t) return;
    var s = (val || '').trim(), on = !!s;
    t.textContent = on ? s : ph;
    t.setAttribute('opacity', on ? '1' : '.3');
    var fs = base;
    if (maxw) fs = Math.min(base, maxw / (Math.max(t.textContent.length, 1) * 0.66));
    t.setAttribute('font-size', fs.toFixed(1));
  }

  function paintRow(r) {
    var el = $('[data-row="' + r.id + '"]'); if (!el) return;
    var team = S.noTeam ? '' : effTeam(r);
    var front = $('.tb-pf svg', el), back = $('.tb-pb svg', el);
    fillText(front, 'team', team, 'TEAM', 18, 92);
    fillText(front, 'num', r.num, '00', 60, 96);
    fillText(back, 'name', r.noName ? '' : r.name, 'NAME', 20, 80);
    fillText(back, 'bnum', r.backDiff ? r.backNum : r.num, '00', 66, 100);

    var iss = issues(r), st = $('.tb-rstate', el);
    if (!iss.length) { st.className = 'tb-rstate is-ok'; st.textContent = 'Ready'; }
    else if (S.tried) { st.className = 'tb-rstate is-todo'; st.textContent = 'Needs ' + iss.join(', '); }
    else { st.className = 'tb-rstate'; st.textContent = plural(iss.length, 'field') + ' left'; }

    var bad = { size: !r.size, num: !validNum(r.num), bnum: r.backDiff && !validNum(r.backNum), name: !r.noName && !r.name.trim() };
    for (var k in bad) {
      var f = $('[data-f="' + k + '"]', el); if (!f) continue;
      var b = S.tried && bad[k];
      f.classList.toggle('is-bad', b);
      var inp = f.querySelector('input:not([type=checkbox]),select'); if (inp) inp.setAttribute('aria-invalid', b ? 'true' : 'false');
    }
    el.classList.toggle('is-bad', S.tried && iss.length > 0);
    var cnt = $('.tb-f-name .tb-count', el); if (cnt) cnt.textContent = r.name.length + '/14';
  }
  function paintAll() { S.rows.forEach(paintRow); }

  /* ---------- summary ---------- */
  function lineText(r) {
    var team = S.noTeam ? '' : effTeam(r).trim(), nm = r.noName ? '' : r.name.trim(), bn = r.backDiff ? r.backNum : r.num;
    var f = [team, r.num].filter(Boolean).join(' · ') || '—';
    var b = [nm, bn].filter(Boolean).join(' · ') || '—';
    return esc(f) + ' <i>/</i> ' + esc(b);
  }
  function updateSummary() {
    var n = S.rows.length, ready = S.rows.filter(function (r) { return issues(r).length === 0; }).length;
    $('#tb-sum-logo').textContent = S.logo ? (S.logo.link ? 'Link' : S.logo.name) : 'None';
    $('#tb-sum-team').textContent = S.noTeam ? 'None' : (S.teamEach ? (S.team || 'Varies') : (S.team || '—'));
    $('#tb-ready-txt').textContent = ready + ' of ' + plural(n, 'jersey') + ' ready';
    $('#tb-meter-i').style.width = (n ? ready / n * 100 : 0) + '%';
    $('#tb-meter-i').parentNode.classList.toggle('is-full', ready === n);

    var lines = '';
    S.rows.forEach(function (r, i) {
      var ok = issues(r).length === 0;
      lines += '<li><button type="button" data-go="' + r.id + '"><span class="tb-ln">' + (i + 1) + '</span><span class="tb-lsz">' + esc(r.size || '—') + '</span><span class="tb-lp">' + lineText(r) + '</span><span class="tb-ls ' + (ok ? 'is-ok' : (S.tried ? 'is-todo' : '')) + '"></span></button></li>';
    });
    $('#tb-lines').innerHTML = lines;

    var total = n * CFG.unitPrice;
    $('#tb-unit-txt').textContent = n + ' × ' + money(CFG.unitPrice);
    $('#tb-was').textContent = CFG.compareAt && CFG.compareAt > CFG.unitPrice ? money(n * CFG.compareAt) : '';
    $('#tb-total').textContent = money(total);
    $('#tb-bar-total').textContent = money(total);
    $('#tb-bar-n').textContent = plural(n, 'jersey') + (ready < n ? ' · ' + (n - ready) + ' to finish' : ' · ready');
    var tOk = teamOk();
    var label, barLabel;
    if (ready < n) { label = 'Finish ' + (n - ready) + ' to add to cart'; barLabel = 'Finish ' + (n - ready); }
    else if (!tOk) { label = 'Add your team name to continue'; barLabel = 'Add team name'; }
    else { label = 'Add ' + plural(n, 'jersey') + ' to cart'; barLabel = 'Add to cart'; }
    $('#tb-cta-txt').textContent = label;
    $('#tb-bar-cta').textContent = barLabel;
    var done = { logo: !!S.logo, players: ready === n && n > 0 && tOk, review: ready === n && n > 0 && tOk };
    $$('#tb-steps li').forEach(function (li) {
      var k = li.getAttribute('data-step');
      li.classList.toggle('is-done', !!done[k]);
      var sv = $('.tb-sv', li);
      sv.textContent = k === 'logo' ? (S.logo ? '' : 'optional') : (k === 'players' ? (ready === n ? '' : ready + '/' + n) : '');
    });
    var tf = $('#tb-team-f'); tf.classList.toggle('is-bad', S.tried && !tOk && !S.teamEach);
    $('#tb-team').setAttribute('aria-invalid', (S.tried && !tOk && !S.teamEach) ? 'true' : 'false');
    var st = $('#tb-sum-team'); st.classList.toggle('is-miss', S.tried && !tOk);
    $('#tb-team-count').textContent = S.team.length + '/16';
  }

  function afterChange(r) {
    if (r) paintRow(r); else paintAll();
    updateSummary(); save();
  }

  /* ---------- row structure changes ---------- */
  function setCount(n) {
    n = Math.max(1, Math.min(MAX, n || 1));
    if (n === S.rows.length) { $('#tb-qty').value = n; return; }
    if (n > S.rows.length) {
      while (S.rows.length < n) S.rows.push(newRow());
      renderRows(); updateSummary(); save();
      return;
    }
    var removed = S.rows.splice(n);
    var hadData = removed.some(function (r) { return r.size || r.num || r.name; });
    renderRows(); updateSummary(); save();
    if (hadData) { S.undo = { items: removed.map(function (r, i) { return { r: r, at: n + i }; }) }; toast('Removed ' + plural(removed.length, 'jersey') + '.', 'Undo', undoRemove); }
  }
  function undoRemove() {
    if (!S.undo) return;
    S.undo.items.forEach(function (it) { S.rows.splice(Math.min(it.at, S.rows.length), 0, it.r); });
    S.undo = null; renderRows(); updateSummary(); save();
  }
  function focusRow(id, what) {
    var el = $('[data-row="' + id + '"]'); if (!el) return;
    scrollTo(el);
    var t = $(what === 'name' ? '[data-k="name"]' : '[data-k="size"]', el);
    if (t) setTimeout(function () { try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); } }, reduce ? 0 : 260);
  }

  /* ---------- cart lines ---------- */
  function buildLines() {
    var n = S.rows.length;
    return S.rows.map(function (r, i) {
      var team = S.noTeam ? 'NONE' : effTeam(r).trim(), bn = r.backDiff ? r.backNum : r.num;
      var p = {
        'Jersey': (i + 1) + ' of ' + n,
        'Team Name (Front)': team,
        'Number (Front)': r.num,
        'Name (Back)': r.noName ? 'NONE' : r.name.trim(),
        'Number (Back)': bn,
        'Number (Shorts)': r.num,
        'Logo': S.logo ? (S.logo.link ? 'Link provided' : 'Uploaded: ' + S.logo.name) : 'None'
      };
      if (S.logo && S.logo.url) p['_Logo URL'] = S.logo.url;
      return { id: sizeById[r.size].id, size: r.size, quantity: 1, properties: p };
    });
  }

  function firstBad() {
    for (var i = 0; i < S.rows.length; i++) if (issues(S.rows[i]).length) return S.rows[i];
    return null;
  }
  function submit() {
    S.tried = true;
    var lk = $('#tb-logo-link');
    if (!S.logo && lk && lk.value.trim()) {
      if (/^https?:\/\/\S+\.\S+/i.test(lk.value.trim())) S.logo = { name: 'Logo link', url: lk.value.trim(), link: true, grade: 'link' };
    }
    paintAll(); updateSummary();
    if (!teamOk() && !S.teamEach) { scrollTo($('#tb-team')); $('#tb-team').focus({ preventScroll: true }); toast('Add your team name, or tick "No team name".'); return; }
    var bad = firstBad();
    if (bad) {
      var which = issues(bad)[0];
      var idx = S.rows.indexOf(bad) + 1;
      focusRow(bad.id, which === 'name' ? 'name' : 'size');
      var el = $('[data-row="' + bad.id + '"]');
      var key = { size: 'size', number: 'num', 'back number': 'backNum', name: 'name', 'team name': 'team' }[which];
      var inp = el && $('[data-k="' + key + '"]', el);
      if (inp) setTimeout(function () { try { inp.focus({ preventScroll: true }); } catch (e) {} }, reduce ? 0 : 260);
      toast('Jersey ' + idx + ' still needs: ' + issues(bad).join(', ') + '.');
      return;
    }
    addToCart();
  }

  var busy = false, slowT = null;
  function setBusy(on, label) {
    busy = on;
    var b1 = $('#tb-cta'), b2 = $('#tb-bar-cta');
    [b1, b2].forEach(function (b) { if (!b) return; if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy'); b.disabled = on; });
    if (on) { $('#tb-cta-txt').textContent = label; b2.textContent = label; } else updateSummary();
  }
  function cartHref(rootUrl) { return CFG.cartUrl || (rootUrl + 'cart'); }
  function addToCart() {
    if (busy) return;
    var lines = buildLines();
    var err = $('#tb-carterr'), ok = $('#tb-cartok');
    err.hidden = true; ok.hidden = true;
    if (CFG.mock) { showReceipt(lines); return; }
    setBusy(true, 'Adding to cart…');
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var href = cartHref(rootUrl);
    /* if the store is slow, say so and offer a way out. No abort: the items may already be in the cart. */
    clearTimeout(slowT);
    slowT = setTimeout(function () {
      ok.innerHTML = 'This is taking longer than usual. Your jerseys may already be in your cart. <a href="' + esc(href) + '">View cart</a>';
      ok.hidden = false;
    }, 8000);
    fetch(rootUrl + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: lines.map(function (l) { return { id: l.id, quantity: 1, properties: l.properties }; }) })
    }).then(function (res) {
      return res.json().then(function (j) { if (!res.ok) throw new Error(j.description || j.message || 'The cart could not be updated.'); return j; });
    }).then(function () {
      setBusy(true, 'Added. Opening your cart…');
      ok.innerHTML = 'Added to your cart. <a href="' + esc(href) + '">Open cart</a>';
      ok.hidden = false;
      try { localStorage.removeItem(LS); } catch (e) {}
      var attrs = { 'Team Name': S.noTeam ? 'NONE' : (S.teamEach ? 'Varies by jersey' : S.team.trim()) };
      if (S.logo && S.logo.url) attrs['Logo URL'] = S.logo.url;
      /* the order attributes are a nice-to-have: never let them block the redirect */
      var upd = fetch(rootUrl + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs }) }).catch(function () {});
      var cap = new Promise(function (r) { setTimeout(r, 2500); });
      return Promise.race([upd, cap]);
    }).then(function () {
      clearTimeout(slowT);
      window.location.assign(href);
    }).catch(function (e) {
      clearTimeout(slowT);
      ok.hidden = true;
      setBusy(false);
      err.textContent = (e && e.message ? e.message : 'The cart could not be updated.') + ' Your entries are saved. Please try again.';
      err.hidden = false;
    });
  }

  function showReceipt(lines) {
    var m = $('#tb-order'); if (!m) return;
    var rows = lines.map(function (l) {
      var p = l.properties;
      return '<tr><td>' + esc(p['Jersey']) + '</td><td>' + esc(l.size) + '</td><td>' + esc(p['Team Name (Front)']) + '</td><td>' + esc(p['Number (Front)']) + '</td><td>' + esc(p['Name (Back)']) + '</td><td>' + esc(p['Number (Back)']) + '</td><td>' + esc(p['Number (Shorts)']) + '</td><td>' + esc(p['Logo']) + '</td></tr>';
    }).join('');
    $('#tb-order-body').innerHTML = rows;
    var payload = { items: lines.map(function (l) { return { id: l.id, quantity: 1, properties: l.properties }; }) };
    $('#tb-order-json').textContent = JSON.stringify(payload, null, 2);
    m.hidden = false; $('#tb-order-x').focus();
  }

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target;
    var lg = t.closest && t.closest('[data-logo]');
    if (lg) {
      if (lg.getAttribute('data-logo') === 'remove') { S.logo = null; logoErr = ''; renderLogo(); updateSummary(); save(); }
      else { var fi = $('#tb-file'); if (fi) fi.click(); }
      return;
    }
    var op = t.closest && t.closest('[data-open="chart"]');
    if (op) { var m = $('#tb-chart'); m.hidden = false; m._from = op; $('#tb-chart-x').focus(); return; }
    if (t.closest && t.closest('[data-close="chart"]')) { closeChart(); return; }
    if (t.id === 'tb-chart') { closeChart(); return; }
    if (t.closest && t.closest('[data-close="order"]')) { $('#tb-order').hidden = true; return; }

    var act = t.closest && t.closest('[data-act]');
    if (act) {
      var rowEl = act.closest('[data-row]'), r = rowEl && rowById(+rowEl.getAttribute('data-row'));
      var a = act.getAttribute('data-act');
      if (!r) return;
      if (a === 'bnum') {
        r.backDiff = !r.backDiff; if (r.backDiff && !r.backNum) r.backNum = r.num;
        var box = $('.tb-f-bnum', rowEl); box.hidden = !r.backDiff;
        act.textContent = r.backDiff ? 'Use the same number on the back' : 'Back number is different';
        if (r.backDiff) { var bi = $('[data-k="backNum"]', rowEl); bi.value = r.backNum; bi.focus(); }
        afterChange(r);
      } else if (a === 'del') {
        if (S.rows.length < 2) return;
        var at = S.rows.indexOf(r); S.rows.splice(at, 1);
        var had = r.size || r.num || r.name;
        renderRows(); updateSummary(); save();
        if (had) { S.undo = { items: [{ r: r, at: at }] }; toast('Jersey removed.', 'Undo', undoRemove); }
      } else if (a === 'same') {
        if (S.rows.length >= MAX) { toast('You can order up to ' + MAX + ' jerseys at once. For bigger teams, contact us.'); return; }
        var nr = newRow({ size: r.size, team: r.team }); S.rows.splice(S.rows.indexOf(r) + 1, 0, nr);
        renderRows(); updateSummary(); save(); focusRow(nr.id, 'num');
        var ni = $('[data-row="' + nr.id + '"] [data-k="num"]'); if (ni) setTimeout(function () { ni.focus({ preventScroll: true }); }, reduce ? 0 : 260);
      }
      return;
    }
    var go = t.closest && t.closest('[data-go]');
    if (go) { var gr = rowById(+go.getAttribute('data-go')); var ge = $('[data-row="' + go.getAttribute('data-go') + '"]'); scrollTo(ge); return; }
    if (t.closest && (t.closest('#tb-cta') || t.closest('#tb-bar-cta'))) { submit(); return; }
    if (t.closest && t.closest('#tb-addrow')) {
      if (S.rows.length >= MAX) { toast('You can order up to ' + MAX + ' jerseys at once.'); return; }
      var r2 = newRow(); S.rows.push(r2); renderRows(); updateSummary(); save(); focusRow(r2.id, 'size'); return;
    }
    if (t.id === 'tb-qplus') { setCount(S.rows.length + 1); return; }
    if (t.id === 'tb-qminus') { setCount(S.rows.length - 1); return; }
  });

  function closeChart() { var m = $('#tb-chart'); m.hidden = true; if (m._from) m._from.focus(); }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { var c = $('#tb-chart'); if (c && !c.hidden) closeChart(); var o = $('#tb-order'); if (o && !o.hidden) o.hidden = true; }
  });

  root.addEventListener('input', function (e) {
    var t = e.target, k = t.getAttribute && t.getAttribute('data-k');
    if (t.id === 'tb-team') {
      var v = cleanText(t.value, 16); if (v !== t.value) t.value = v; S.team = v;
      $$('[data-k="team"]').forEach(function (i) { i.placeholder = v || 'Same as above'; });
      afterChange(); return;
    }
    if (t.id === 'tb-qty') return;
    if (t.id === 'tb-logo-link') return;
    var rowEl = t.closest && t.closest('[data-row]'); if (!rowEl || !k) return;
    var r = rowById(+rowEl.getAttribute('data-row')); if (!r) return;
    if (k === 'num') { var d1 = digits(t.value); if (d1 !== t.value) t.value = d1; r.num = d1; }
    else if (k === 'backNum') { var d2 = digits(t.value); if (d2 !== t.value) t.value = d2; r.backNum = d2; }
    else if (k === 'name') { var nv = cleanText(t.value, 14); if (nv !== t.value) t.value = nv; r.name = nv; }
    else if (k === 'team') { var tv = cleanText(t.value, 16); if (tv !== t.value) t.value = tv; r.team = tv; }
    afterChange(r);
  });

  root.addEventListener('change', function (e) {
    var t = e.target, k = t.getAttribute && t.getAttribute('data-k');
    if (t.id === 'tb-noteam') { S.noTeam = t.checked; $('#tb-team').disabled = S.noTeam; afterChange(); return; }
    if (t.id === 'tb-teameach') {
      S.teamEach = t.checked;
      $$('.tb-f-team').forEach(function (f) { f.hidden = !S.teamEach; });
      $('#tb-team-lbl').firstChild.textContent = S.teamEach ? 'Default team name ' : 'Team name ';
      afterChange(); return;
    }
    if (t.id === 'tb-qty') { setCount(parseInt(t.value, 10)); return; }
    if (t.id === 'tb-file') { handleFile(t.files && t.files[0]); t.value = ''; return; }
    if (t.id === 'tb-logo-link') { var u = t.value.trim(); var f = $('#tb-linkf'); if (!u) { f.classList.remove('is-bad'); return; } if (/^https?:\/\/\S+\.\S+/i.test(u)) { f.classList.remove('is-bad'); S.logo = { name: 'Logo link', url: u, link: true, grade: 'link' }; renderLogo(); updateSummary(); save(); } else f.classList.add('is-bad'); return; }
    var rowEl = t.closest && t.closest('[data-row]'); if (!rowEl || !k) return;
    var r = rowById(+rowEl.getAttribute('data-row')); if (!r) return;
    if (k === 'size') r.size = t.value;
    else if (k === 'noName') { r.noName = t.checked; var ni = $('[data-k="name"]', rowEl); ni.disabled = r.noName; if (r.noName) { r.name = ''; ni.value = ''; } }
    afterChange(r);
  });

  root.addEventListener('keydown', function (e) {
    var t = e.target;
    if (e.key === 'Enter' && t.getAttribute && t.getAttribute('data-k') === 'name') {
      e.preventDefault();
      var rowEl = t.closest('[data-row]'), r = rowById(+rowEl.getAttribute('data-row')), i = S.rows.indexOf(r);
      if (i < S.rows.length - 1) focusRow(S.rows[i + 1].id, 'size');
      else if (S.rows.length < MAX) { var nr = newRow({ size: r.size }); S.rows.push(nr); renderRows(); updateSummary(); save(); focusRow(nr.id, 'size'); }
    }
  });

  /* drag and drop for the logo */
  root.addEventListener('dragover', function (e) { var d = e.target.closest && e.target.closest('#tb-drop'); if (d) { e.preventDefault(); d.classList.add('is-drag'); } });
  root.addEventListener('dragleave', function (e) { var d = e.target.closest && e.target.closest('#tb-drop'); if (d) d.classList.remove('is-drag'); });
  root.addEventListener('drop', function (e) { var d = e.target.closest && e.target.closest('#tb-drop'); if (d) { e.preventDefault(); d.classList.remove('is-drag'); handleFile(e.dataTransfer.files && e.dataTransfer.files[0]); } });

  /* sticky bar: show while the builder is on screen and the summary is not */
  (function () {
    var bar = $('#tb-bar'), sum = $('#tb-s-review'), main = $('.tb-main');
    if (!('IntersectionObserver' in window)) return;
    var inMain = false, inSum = false;
    function sync() { var on = inMain && !inSum; bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); $('#tb-bar-cta').tabIndex = on ? 0 : -1; }
    new IntersectionObserver(function (en) { inMain = en[0].isIntersecting; sync(); }, { rootMargin: '0px 0px -80px 0px' }).observe(main);
    new IntersectionObserver(function (en) { inSum = en[0].isIntersecting; sync(); }, { rootMargin: '0px 0px -40px 0px' }).observe(sum);
  })();

  /* ---------- boot ---------- */
  $('#tb-rec-px').textContent = REC_PX; $('#tb-min-px').textContent = MIN_PX; $('#tb-max-mb').textContent = MAX_MB;
  $('#tb-qty').max = MAX;
  if (!$('#tb-chart-table')) $$('[data-open="chart"]').forEach(function (b) { b.hidden = true; });
  var restored = load();
  applyPalette(); fillProduct(); renderLogo(); renderRows(); updateSummary();
  $('#tb-team').value = S.team; $('#tb-noteam').checked = S.noTeam; $('#tb-team').disabled = S.noTeam; $('#tb-teameach').checked = S.teamEach;
  if (S.teamEach) $('#tb-team-lbl').firstChild.textContent = 'Default team name ';
  $('#tb-team-count').textContent = S.team.length + '/16';
  if (restored) toast('Restored your unfinished order.', 'Start over', function () { try { localStorage.removeItem(LS); } catch (e) {} location.reload(); });
})();
